var render = function render(){var _vm=this,_c=_vm._self._c;return _c('barcode',{attrs:{"value":"value-to-render","format":"barcode-format","id":"barcode"}},[_vm._v("\n    Show this if the rendering fails.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }